import { z } from "zod";

const tagSchema = z
  .object({
    name: z.string().min(1),
    url: z.string().url().catch(""),
    following: z.boolean().catch(false), // TODO: deprecate
    recent_history: z.array(z.number()).catch([]),
    recent_statuses_count: z.number(),
  })
  .transform((tag) => {
    return {
      ...tag,
      id: tag.url, // add unique "id" to support TEntity in API
    };
  });

type Tag = z.infer<typeof tagSchema>;

export { tagSchema, type Tag };
